<template>
<div class="page-body ph-30">
  <div ui-view="" class="app-body" id="view">
      <div class="calendar_container">
        <div class="control-group">
          <div class="inner-wrap">
            <div class="input-group align-top">
              <dropdown v-model="selectedYear" :datasource="yearList" title="" :width="115" @changeValue="changeDate"/>
            </div>

            <div class="input-group mr-6">

              </div>
            </div>
            <button class="btn btn-m line-2 mr-6" @click="addMonth(-1)"><i class="icon-arrow-line-left-centered" ></i></button>
            <div class="input-group align-top mr-6">
              <dropdown v-model="selectedMonth" :datasource="monthList" title="" :width="115" @changeValue="changeDate"/>
            </div>
            <button class="btn btn-m line-2 mr-6" @click="addMonth(1)"><i class="icon-arrow-line-right-centered"></i></button>
            <button class="btn btn-md line-2" @click="setCurrentDate()">현재</button>
          </div>
        </div>
        <div class="monthly_calendar">
          <table class="calendar_header">
            <caption class="blind">일정 캘린더 요일 표시 테이블</caption>
            <tbody>
              <tr>
                <th class="holiday" title="日">일</th>
                <th title="一">월</th>
                <th title="二">화</th>
                <th title="三">수</th>
                <th title="四">목</th>
                <th title="五">금</th>
                <th class="holiday" title="六">토</th>
              </tr>
            </tbody>
          </table>
          <!-- [D] 세로 화면 축소 시 height값 조절해주세요. (최소높이 541px 최대높이 732px) -->
          <!-- [D] 일정 한줄만 노출 시 control_row클래스 추가,
                                  일정 두줄 노출 시 control_row2클래스 추가. -->
          <div class="month_table" style="height: 750px;">
            <div class="month_row" v-for="(item, index) in getWeek" :key="item">
              <table class="grid">
                <tbody>
                  <tr>
                    <td class="month_cell"></td>
                    <td class="month_cell"></td>
                    <td class="month_cell"></td>
                    <td class="month_cell"></td>
                    <td class="month_cell"></td>
                    <td class="month_cell"></td>
                    <td class="month_cell"></td>
                  </tr>
                </tbody>
              </table>
              <table class="schedule_list">
                <caption class="blind">일정 캘린더 테이블</caption>
                <tbody>
                  <tr class="date">
                    <td :class="[dayItem.isHoliday ? 'holiday' : '', dayItem.isToday ? 'today' : '']" v-for="(dayItem, dayIndex) in getDays(item)" :key="dayIndex"><strong>{{dayItem.day}}</strong><i class="icon-eyes"></i></td>
                  </tr>
                  <tr class="schedule_row row0">
                    <td :day-of-week="bookItem0Index" :day-index="(index * 7) + bookItem0Index" v-for="(bookItem0, bookItem0Index) in getDays(item)" :date="bookItem0.date" :key="bookItem0Index">&nbsp;</td>
                  </tr>
                  <tr class="schedule_row row1">
                    <td :day-of-week="bookItem0Index" :day-index="(index * 7) + bookItem0Index" v-for="(bookItem0, bookItem0Index) in getDays(item)" :date="bookItem0.date" :key="bookItem0Index">&nbsp;</td>
                  </tr>
                  <tr class="schedule_row row2">
                    <td :day-of-week="bookItem0Index" :day-index="(index * 7) + bookItem0Index" v-for="(bookItem0, bookItem0Index) in getDays(item)" :date="bookItem0.date" :key="bookItem0Index">&nbsp;</td>
                  </tr>
                  <tr class="schedule_row more">
                    <td :day-of-week="bookItem0Index" :day-index="(index * 7) + bookItem0Index" v-for="(bookItem0, bookItem0Index) in getDays(item)" :date="bookItem0.date" :key="bookItem0Index">
                      <div class="more mt-15" style="display:none">
                        +&nbsp;<span class="more_num">0</span>&nbsp;
                        <div class="dropdown inline">
                          <button class="btn btn-s line-2 icon-arrow-line-down" data-toggle="dropdown" aria-expanded="true"></button>
                          <div class="dropdown-menu dropdown-menu-scale">
                            <ul>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <!--div class="loading loading-md">
              <div class="sk-fading-circle">
                <div class="sk-circle1 sk-circle"></div>
                <div class="sk-circle2 sk-circle"></div>
                <div class="sk-circle3 sk-circle"></div>
                <div class="sk-circle4 sk-circle"></div>
                <div class="sk-circle5 sk-circle"></div>
                <div class="sk-circle6 sk-circle"></div>
                <div class="sk-circle7 sk-circle"></div>
                <div class="sk-circle8 sk-circle"></div>
                <div class="sk-circle9 sk-circle"></div>
                <div class="sk-circle10 sk-circle"></div>
                <div class="sk-circle11 sk-circle"></div>
                <div class="sk-circle12 sk-circle"></div>
              </div>
            </div>
          </div-->
        </div>
        <div id="tooltip" class="calender-tooltip" v-show="tooltipShow">
          <div id="tooltip-header">
            <div class="close-btn" @click="tooltipShow=false" style="cursor:pointer">
              <i class="icon-close"></i>
            </div>
          </div>
          <div class="tooltip-body">
            <ul class="list-group" style="color:#333">
              <li class="list-group-item bullet-2" v-for="(item, index) in tooltipDataList" :key="index" >
                <p>
                  <i class="circle bullet" style="font-size: 10px;">{{index+1}}</i>{{item ? item.bookName : ''}}
                </p>
                <h5>{{item ? getDateSimple(item.start) : null }}~{{item ? getDateSimple(getAddDate(item.end, -1)) : null}}</h5>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div class="mt-10">
        <span class="tag warning mr-6">출입 승인 대기</span>
        <span class="tag success mr-6">출입 승인 완료</span>
        <span class="tag danger mr-6">출입 거절</span>
      </div>
  </div>
</div>

</template>

<script>
import Dropdown from '@/components/Dropdown.vue';
export default {
  components: { Dropdown },

  data(){
    return {
      tooltipShow: false,
      tooltipDataList: [],
      bookList: [
      ],
      selectedYear: null,
      selectDate: null,
      selectedMonth: null,
      dayList: null,
      isLoad: true,
      //monthList: []
    }
  },
  computed: {
    getAddDate(){
      return (date, add)=>{
        return moment(date).add(add, 'd');
      }
    },
    firstWeek(){
      //var today = moment();

      return this.selectDate.clone().startOf('month').week();
    },
    lastWeek(){
      //var today = moment();
      return this.selectDate.clone().endOf('month').week() === 1 ? 53 : this.selectDate.clone().endOf('month').week();
    },
    yearList(){
      var start = Number(moment().add(-3, 'y').year())
      var result = [];
      for(var i = start; i < start + 10; i++){
        var o = {name: i + '년', value: i}
        result.push(o);
      }
      return result;
    },
    monthList(){

      var result = [];
      for(var i = 0; i < 12; i++){
        var o = {name: (i+1) + '월', value: i}
        result.push(o);
      }
      return result;
    },
    getWeek(){
      //var today = moment();
      var week = this.firstWeek
      var result = [];
      for(week; week <= this.lastWeek; week++){
        result.push(week)
      }
      return result;
    },
    getDays(){
      return (week) =>{
        //var today = moment();
        var result = [];
        var that = this;
        Array(7).fill(0).map((data, index) => {

          var days = that.selectDate.clone().startOf('year').week(week).startOf('week').add(index, 'day');
          var isHoliday = () =>{
            if(days.days() == 0 || days.days() == 6)
              return true;
            else
              return false;
          }
          var o = {day: days.format('D'), dayOfWeek: days.days(), isHoliday: isHoliday(), date: days.format('YYYY-MM-DD'), isToday: moment().isSame(days,'day')}
          result.push(o);
        })
        return result;
      }
    },
    currentIdc(){
      console.log(this.$store.state.location.currentIdc);
      return this.$store.state.location.currentIdc;
    },
  },
  watch: {
    currentIdc(nVal, oVal){
      //모든 로우 초기화
      $('.schedule').each(function(){
        console.log($(this));
        $(this).remove();
      })
      this.loadData();
    }
  },
  created(){
    this.setCurrentDate();
  },
  mounted(){
    //$('#tooltip').hide();
  },
  methods: {
    init(){
      this.booName();
    },
    makeDayList(){
      var today = this.selectDate.clone();
      var week = this.firstWeek;
      var that = this;
      this.dayList = [];
      var i = 0;
      for(week; week <= this.lastWeek; week++){
        Array(7).fill(0).map((data, index) => {
          var days = today.clone().startOf('year').week(week).startOf('week').add(index, 'day');
          that.dayList.push({timestamp: days.valueOf(), day: days.format('D'), dateString: days.format("YYYY-MM-DD"), date: days.clone(), dayIndex: (i * 7) + index})
          // console.log(days.format('D'))

        })
        i++;
      }
      this.loadData();
    },
    findTd(){
      var today = moment();
      var week = this.firstWeek
      for(week; week <= this.lastWeek; week++){
        Array(7).fill(0).map((data, index) => {
          var days = today.clone().startOf('year').week(week).startOf('week').add(index, 'day');

          // console.log(days.format('D'))

        })
      }
    },
    isBetweenDate(compareDate, start, end){
      //var compareDate = nu
      var result = false;
      var startDate   = moment(start);
      var endDate     = moment(end);
      if(compareDate.isBetween(startDate, endDate))
        result = true;
      if(compareDate.isSame(startDate, 'days') || compareDate.isSame(endDate, 'days'))
        result = true;
      // omitting the optional third parameter, 'units'
      return result;//false in this case
    },
    checkTd(x){
      var result = -1;
      if(x.ticket == "REQ20210916000002") {

      }
      for(var i=0; i < 3; i++){
        var element = $(".schedule_row"+".row"+i+">td[date=" +moment(x.start).format('YYYY-MM-DD')+"]")
        var prevElement = $(".schedule_row"+".row"+i+">td[date=" +moment(x.start).clone().add(-1, 'days').format('YYYY-MM-DD')+"]")
        if(element.find('#'+x.ticket).length) {
          result = i;
          break;
        }
        if(element.length > 0 && $(element).children().length == 0){
          result = i;
          break;
        }
      }
      for(var i=0; i < 3; i++){
        var prevElement = $(".schedule_row"+".row"+i+">td[date=" +moment(x.start).clone().add(-1, 'days').format('YYYY-MM-DD')+"]")
        if(prevElement.find('#'+x.ticket).length) {
          result = i;
          //break;
        }
      }
      return result;
    },

    checkSameDuration(x){
      var that = this;
      var endIndex = _.findIndex(this.bookList, function(y){ return y.id == x.id; });
      var beforeList = _.slice(this.bookList, 0, endIndex);
      var sameCount = 0;
      beforeList.forEach((y)=>{
        /*
        var endDate = moment(x.start).clone();
        var startDate = moment(x.end).clone();
        while(startDate.diff(endDate, 'days') < 0){
          if(that.isBetweenDate(startDate, y.start, e.end)){
            sameCount++;
            break;
          }
          startDate.add(1,'days');
        }*/

        var endDate = moment(y.end);
        var startDate = moment(y.start);
        while(startDate.diff(endDate, 'days') < 0){

          if(that.isBetweenDate(startDate, x.start, x.end)){
            //if(!endDate.clone().add(-1, 'days').isSame(x.start, 'day')){
              sameCount++;
              break;
            //}
          }
          startDate.add(1,'days');
        }


      })
      return sameCount;
    },
    getStatusColor(statusCode){
      /*
      1.2 승인대기 - 노랑
      3, 5~8 승인완료 - 녹색
      4 승인 거절 - 회색
      */
      var color = '#eab416'
      if(statusCode == 1 || statusCode == 2) color = '#eab416';
      else if(statusCode == 3 || statusCode == 5 || statusCode == 6 || statusCode == 7 || statusCode == 8) color = '#00c73c';
      else if(statusCode == 4) color = '#f84d3a';
      return color;
    },
    //특정날짜가 포함되어있는 전부를 가저옴
    getDataInDate(compareDate){
      var that = this;
      var result = [];
      this.bookList.forEach(x=>{
        if(that.isBetweenDate(moment(compareDate), x.start, x.end)){
          result.push(x);
        }
      })
      return result;
    },
    makeLineSchedule(x){
      var that = this;
      var tx = moment.duration((moment(x.end).diff(x.start))).asDays();
      //var selectedRow = '.row' + this.checkSameDuration(x);
      //var selectedRow = '.row'  + this.checkTd(x);
      var week = 1;

      //var el = $(".schedule_row"+selectedRow+">td[date=" +moment(x.start).format('YYYY-MM-DD')+"]")
      //if(!el || el.length == 0){
        /*
        if(this.checkSameDuration(x) > 2){

          this.makeDropSchedule(x);
          return;
        }
        */
      //}
      //var dow = el.attr('day-of-week');

      if(tx < 7)
        week = 1;
      else
        week = Math.ceil(tx/7);
      var startDate = moment(x.start);
      var currentDate = startDate.clone();
      var weekList = [];
      var startWeek = moment(x.start).week();
      var firstWeek = this.firstWeek;
      var currentWeek = startWeek;
      var rows = [];
      var diffWeek = 0;
      var colSapn = 0;
      var c


      //데이터의 시작날짜부터 종료날짜까지 루프를 돌면서 주별 합칠 TD와 로우등을 만든다.
      for(var i = 0; i < tx; i++) {

        while(currentDate.valueOf() < moment(x.end).valueOf()){
          var o = this.copyNew(x);
          o.start = currentDate;

          var cRow = this.checkTd(o);
          var selectedRow = '.row'  + cRow;
          if(cRow < 0)
            selectedRow = '.more'
          var beforeItems = rows.filter(y=>y.ticket == x.ticket && y.start.valueOf() < currentDate.valueOf())
          if(beforeItems.length > 0){

            if(beforeItems[beforeItems.length-1].selectedRow > 0)
              selectedRow = '.row' +beforeItems[beforeItems.length-1].selectedRow;
          }
          var element = $(".schedule_row"+selectedRow+">td[date=" +currentDate.format('YYYY-MM-DD')+"]");
          rows.push({start: currentDate.clone(), el: element, colSapn: colSapn, deleteEl: [], ticket: x.ticket, selectedRow: cRow});
          currentDate.add(1,'days');
        }
      }
      if(x.ticket == "REQ20210916000002") {

      }
      //앞에 로우에 따라 뒤도 같이 맞추기
      rows.forEach((v, index)=>{
        if(index != 0){
          if(rows[index-1].selectedRow >= 0){
            v.selectedRow = rows[index-1].selectedRow;

            var element = $(".schedule_row"+'.row' + v.selectedRow+">td[date=" +v.start.format('YYYY-MM-DD')+"]");
            v.el = element;
          }
        }
      })
      rows.forEach((v,index)=>{
        if(v.el.children().length == 0){
          $(v.el).empty();
          // $(v.el).clear();
          // $(v.el).append('<div class="schedule" id="'+ x.ticket +'"><span class="schedule_info">' + x.bookName + ' ' + (Number(x.peopleNo) > 0 ? ' 외' + x.peopleNo + '명' : '') + x.ticket+ '</span></div>');
          $(v.el).append('<div rel="tooltip" title="" class="schedule '+x.ticket+'" id="'+ x.ticket +'" style="background: '+this.getStatusColor(x.statusCode)+';"><span class="schedule_info">' + x.bookName + ' ' + (Number(x.peopleNo) > 0 ? ' 외 ' + x.peopleNo + '명' : '') + '</span></div>');
        }
      })

      rows.forEach((v, index)=>{
        if(v.selectedRow >= 0) {
          $(v.el).empty();
          // $(v.el).clear();
          // var txt = x.bookName + ' ' + (Number(x.peopleNo) > 0 ? ' 외' + x.peopleNo + '명' : '') + x.ticket;
          var txt = x.bookName + ' ' + (Number(x.peopleNo) > 0 ? ' 외 ' + x.peopleNo + '명' : '');
          //if($(".schedule_row").find('#' + v.ticket).length > 0)
            //txt = null;

          var list = $(".schedule_row"+".row" + v.selectedRow+">td[date=" +v.start.format('YYYY-MM-DD')+"]").parent().find('#' + v.ticket)
          var limit = list.length;

          $(v.el).append('<div rel="tooltip" title="" class="schedule '+x.ticket+'" id="'+ x.ticket +'" style="background: '+this.getStatusColor(x.statusCode)+';"><span class="schedule_info">' + txt + '</span></div>');
          $(v.el).addClass('pr-0');
          $(v.el).addClass('pl-0');
          if(index == 0 && rows.length > 0){
            $(v.el).removeClass('pl-0');

          }
          if(index == rows.length-1){
            $(v.el).removeClass('pr-0');
          }
          //라벨을 마지막칸이 아니면 absolute
          if($(v.el).attr('day-of-week') < 6 && rows.length > 1){
            $(v.el).find('.schedule_info').css('position', 'absolute');
          }
          if(index != 0){
              $(v.el).find('.schedule_info').hide();

              if(v.el.parent().find('#' + v.ticket).parent()[0] == v.el[0]){
                 $(v.el).find('.schedule_info').show();
              }
          }

          //$(v.el).attr('colspan', v.colSapn);
          v.deleteEl.forEach((d)=>{
            $(d).remove();
          })
        }else{


          //var el = $(v.el).find('.more');
          var dayIndex = v.el.attr('day-index')
          var el = $(".schedule_row.more").find('[day-index='+ dayIndex +']>.more')
          //$(el).find('.dropdown-menu>ul').empty();

          if(el.length < 1)
            return;
          $(el).show();

          var num = Number($(el).find('.more_num').text());
          var appendEl = $('<li/>', {'drop-id': v.id})//'<li><a class="dropdown-item" drop-id="' + x.id +'"></a></li>';
          $(appendEl).append('<a class="dropdown-item '+x.ticket+'"></a>');
          // $(appendEl).find('a').text(x.bookName + ' ' +  (Number(x.peopleNo) > 0 ? (' 외' + x.peopleNo +'명 ') : ' ') + x.ticket);
          $(appendEl).find('a').text(x.bookName + ' ' +  (Number(x.peopleNo) > 0 ? (' 외 ' + x.peopleNo +'명 ') : ' '));

          $(el).find('.dropdown-menu>ul').append(appendEl);
          $(el).find('.more_num').text($(el).find('.dropdown-menu>ul').children().length);

        }
      })

      $('.'+x.ticket).on("click", function(event){
        // console.log("http://localhost:8081/app/inOut/BookList?limit=20&offset=1&visitIdcCode=N2CDT001070&fromDate="+x.start+"&toDate="+x.end+"&ntreeTicket="+x.ticket);

        // let query = {
        //   fromDate: x.start,
        //   toDate: x.end,
        //   ntreeTicket: x.ticket
        // };

        // that.$router.push({ path: '/app/inOut/BookList', query: query});

        let routeData = that.$router.resolve({name: 'inOut.bookList', query: {fromDate: x.start, toDate: x.end, ntreeTicket: x.ticket}});
        window.open(routeData.href, '_blank');
      });





      // $('.'+x.ticket).on("mouseover", function(event){
      //   if(!that.bookList)
      //     return;
      //   var result = that.getDataInDate($(event.currentTarget).parent().attr('date'))
      //   that.tooltipDataList = result; //[result[0], result[0], result[0],result[0], result[0], result[0]]
      //   that.tooltipShow = true;
      //   $('#tooltip').css('top', $(event.currentTarget).parent().parent().parent().offset().top  - $('#mCSB_1_container').position().top);
      //   // console.log("http://localhost:8081/app/inOut/BookList?limit=20&offset=1&visitIdcCode=N2CDT001070&fromDate="+x.start+"&toDate="+x.end+"&ntreeTicket="+x.ticket);
      //   /*
      //   let query = {
      //     fromDate: x.start,
      //     toDate: x.end,
      //     ntreeTicket: x.ticket
      //   };
      //   */
      //
      //   //that.$router.push({ path: '/app/inOut/BookList', query: query});
      // });






      /*
      var cr = Array($('.month_row'));
      cr.forEach((cItem, index)=>{
        var tr = cItem.find('')
        var p = new Array($(cItem).find('#' + x.ticket).parent().parent());
        p = p[0];
        for(var z =0; z < p.length; z ++) {
          var pItem = p[z];
          var s = new Array($(pItem.children).find('#' + x.ticket))
          s = s[0];
          for(var g = 0; g < s.length; g++){
            var sItem = s[g];
            if(g == 0){
              //$(sItem).find('.schedule_info').css('position', 'absolute')
              $(sItem).parent().attr('colspan', s.length);
              if(index == 0 && rows.length > 0){
                $(sItem).parent().removeClass('pl-0');

              }
              if(index == rows.length-1){
                $(sItem).parent().removeClass('pr-0');
              }

            }else{
               $(sItem).parent().remove();
            }
          }
        }
      })
      */

    },
    /*
    makeDropSchedule(x){
      var tx = moment.duration((moment(x.end).diff(x.start))).asDays();

      for(var i = 0; i < tx; i++) {
        var el = $(".schedule_row.more>td[date=" +moment(moment(x.start).add(i, 'd')).format('YYYY-MM-DD')+"]>.more");
        if(el.length < 1)
          return;
        $(el).show();

        var num = Number($(el).find('.more_num').text());
        var appendEl = $('<li/>', {'drop-id': x.id})//'<li><a class="dropdown-item" drop-id="' + x.id +'"></a></li>';
        $(appendEl).append('<a class="dropdown-item"></a>');
        $(appendEl).find('a').text(x.bookName + ' ' +  (Number(x.peopleNo) > 0 ? (' 외' + x.peopleNo +'명 ') : ' ') + x.ticket);


        var liExistEl = $(el).find('.dropdown-menu>ul>li[drop-id='+x.id+']');
        if(liExistEl.length < 1){
          num++;
          $(el).find('.more_num').text(num);
        }
        $(liExistEl).remove();
        $(el).find('.dropdown-menu>ul').append(appendEl);
      }

    },
    */
    makeSchedule(x){
        var that = this;
        var checkSameDuration = this.checkSameDuration(x);
        this.makeLineSchedule(x);
        /*
        if(checkSameDuration < 3){
          this.makeLineSchedule(x);
        }else{

          this.makeDropSchedule(x);
        }
        */

    },
    loadData(){
      var that = this;
      if(!this.isLoad)
        return;
      this.isLoad = false;
      setTimeout(()=>{
        that.isLoad = true;
      }, 500)
      this.$http.get('/api/private/visitor/calendar/'+this.currentIdc.locationCode + '/' + this.selectedYear +'/'+ Number(this.selectedMonth + 1))
      // this.$http.get('/api/private/visitor/calendar/'+ this.selectedYear +'/'+ Number(this.selectedMonth + 1))
      .then((result)=>{
        var bookList = [];

        //that.bookList = result.data;
        //var a = result.data.filter(x=>(x.ntreeTicket != 'REQ20210907000008' ) )
        result.data.forEach((x, i)=>{
          /*
          if(x.ntreeTicket == null){
            x.fromDate = 1630940400000
            x.toDate = 1631026740000

          }*/
          var o = {
            id: i, start: moment(x.fromDate).valueOf(),
            end: moment(x.toDate).add(1, 'ms').valueOf(),
            bookName: x.visitorCompany +' '+ x.visitorName,
            peopleNo: x.count, orderNo: 1, ticket: x.ntreeTicket, statusCode: x.statusCode
          };

          bookList.push(o);

          if(moment(o.end).format('HHmmss' == '235959')) {
            o.end = moment(o.end).add(1,'d').startOf('day').valueOf();
          }

        })
        bookList.sort((a,b)=>{
          return moment(b.end).diff(b.start) - moment(a.end).diff(a.start)
        })
        bookList.sort((a,b)=>{
          return moment(a.start).valueOf() - moment(b.start).valueOf()
        })

        that.bookList = bookList;
        that.bookList.forEach((x)=>{
          that.makeSchedule(x);
        })
      })

    },
    setCurrentDate(){
      var beforeDate = null;
      if(this.selectDate)
        var beforeDate = this.selectDate.clone();
      this.selectDate = moment();
      this.selectedYear = this.selectDate.year();
      this.selectedMonth = this.selectDate.month();
      if(beforeDate.valueOf() != this.selectDate.valueOf())
        this.makeDayList();
    },
    changeDate(data){
      var that = this;
      var beforeDate = null;
      if(this.selectDate)
        var beforeDate = this.selectDate.clone();
      setTimeout(()=>{
        var m = moment();
        m.set('year', that.selectedYear);
        m.set('month', that.selectedMonth);
        that.selectDate = m;
        that.tooltipShow = false;
        if(beforeDate.valueOf() != this.selectDate.valueOf())
          this.makeDayList();
      })
    },
    addMonth(add){
      var m = this.selectDate.clone();
      m.add('month',add);

      var y = m.year();
      if(this.yearList.filter((x) => {return x.value == y}).length <= 0)
        return;
      this.selectDate = m.clone();
      this.selectedYear = this.selectDate.year();
      this.selectedMonth = this.selectDate.month();
      this.makeDayList();
    }
  }
}
</script>

<style>

</style>

